import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
const URL = 'https://arit.rmutl.ac.th/survey/api/'
export default {
  getRounds (success, error) {
    Vue.axios.get(URL + 'rounds').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getRoundDetail (key, success, error) {
    Vue.axios.get(URL + 'question/' + key).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getCampus (success, error) {
    Vue.axios.get(URL + 'campus').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getFaculty (success, error) {
    Vue.axios.get(URL + 'facultys').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addQuestion (obj, success, error) {
    Vue.axios.post(URL + 'answer', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addQuestionthree (obj, success, error) {
    Vue.axios.post(URL + 'answer/three', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  login (obj, success, error) {
    Vue.axios.post(URL + 'user/login', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  userQuestDetail (obj, success, error) {
    Vue.axios.post('https://arit.rmutl.ac.th/api/survey/getdata', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  NewStdRmutl (id, success, error) {
    Vue.axios.get('https://arit.rmutl.ac.th/survey/api/user/std/' + id).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getYear (success, error) {
    Vue.axios.get(URL + 'rounds/year').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getDepart (fac, success, error) {
    Vue.axios.get(URL + 'department/' + fac).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_question.js